// extracted by mini-css-extract-plugin
module.exports = {"banner":"experimental-banner-module--banner--1awc1","icon":"experimental-banner-module--icon--2rTbG","text":"experimental-banner-module--text--1in9I"};